/*
 * Copyright (c) Secureroo PTY LTD 2022
 */
export const convertBlobToBase64 = async (blob) => {
  return await blobToBase64(blob);
};

const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
      // console.log(reader.result);
      resolve(reader.result);
    };
    reader.onerror = (error) => reject(error);
  });

export async function downloadFromSDK(
  firebaseConfig,
  storageRef,
  action,
  selector,
  fileName,
  path,
  forceError = false,
  previewOptions = {}
) {
  let bucket = import.meta.env.VITE_storageBucket;

  try {
    if (forceError) {
      throw new Error("Loading Random Image");
    }
    let url;

    try {
      url = await storageRef
      .child(path)
      .getDownloadURL();
      console.log('[DownloadFromSDK@FirstTryCatch] Download URL:', url);
    } catch (error) {
      if (error.code === 'storage/object-not-found') {
        // Silent fail
        url = null;
      } else {
        // Still rethrow other errors to avoid masking problems
        throw error;
      }
    }

    if (!url) {
      console.log('[DownloadFromSDK] URL not found');
      return null;
    }

    let query = url.substring(1);
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) === 'token') {
        let token = decodeURIComponent(pair[1]);
        let removedDoubleSlash = path.replace('/customers/', 'customers/');
        let newUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(
          removedDoubleSlash,
        )}?alt=media&token=${token}`;

        console.log('[DownloadFromSDK@ForEach] Download URL:', newUrl);

        if (action === 'pdf') {
          return newUrl;
        }

        let blob = await new Promise((resolve, reject) => {
          let xhr = new XMLHttpRequest();
          xhr.open('GET', newUrl);
          xhr.responseType = 'blob';
          xhr.onload = () => resolve(xhr.response);
          xhr.onerror = reject;
          xhr.send();
        });

        if (action !== 'pdf') {
          newUrl = window.URL.createObjectURL(blob);
        }

        if (action === 'download') {
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.id = 'magicDL';
          a.href = newUrl;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(newUrl);
          a.remove();
        } else if (action === 'display') {
          document.querySelectorAll(selector).forEach((element) => {
            element.setAttribute('src', newUrl);
          });
        }

        return newUrl;
      }
    }
    // console.log('Query variable %s not found', 'token');
  } catch (error) {
    // if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    //   console.error(error);
    // }
    // Handle errors
    let logoImgNumber = getRandomInt(6);
    const url = await storageRef
      .child(`templates/defaults/default_logos/default_tenancy_logo_${logoImgNumber}.png`)
      .getDownloadURL();

    let query = url.substring(1);
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) === 'token') {
        let token = decodeURIComponent(pair[1]);
        let newUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(
          `templates/defaults/default_logos/default_tenancy_logo_${logoImgNumber}.png`,
        )}?alt=media&token=${token}`;

        if (action === 'pdf') {
          return newUrl;
        }

        let blob = await new Promise((resolve, reject) => {
          let xhr = new XMLHttpRequest();
          xhr.open('GET', newUrl);
          xhr.responseType = 'blob';
          xhr.onload = () => resolve(xhr.response);
          xhr.onerror = reject;
          xhr.send();
        });

        if (action !== 'pdf') {
          newUrl = window.URL.createObjectURL(blob);
        }

        if (action === 'download') {
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.id = 'magicDL';
          a.href = newUrl;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(newUrl);
          a.remove();
        } else if (action === 'display') {
          document.querySelectorAll(selector).forEach((element) => {
            element.setAttribute('src', newUrl);
          });
        }

        return newUrl;
      }
    }
    // console.log('Query variable %s not found', 'token');
  }
}
function getRandomInt(max) {
  return Math.floor(Math.random() * (Math.floor(max) - Math.ceil(1)) + Math.ceil(1));
}

// console.log(downloadFromSDK(firebaseConfig, storageRef, 'display', '#companyImg', 'different_file_name.png', 'logos/logo_test.png', false));

/**
 * Gets the appropriate file type icon or preview component based on file extension
 * @param {string} fileName - File name with extension
 * @returns {string} - File type as a string (image, pdf, txt, docx, xlsx, csv, or other)
 */
export function getFileType(fileName) {
  if (!fileName) return 'other';
  const extension = fileName.split('.').pop().toLowerCase();
  
  if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension)) {
    return 'image';
  } else if (extension === 'pdf') {
    return 'pdf';
  } else if (extension === 'txt') {
    return 'txt';
  } else if (['doc', 'docx'].includes(extension)) {
    return 'docx';
  } else if (['xls', 'xlsx'].includes(extension)) {
    return 'xlsx';
  } else if (extension === 'csv') {
    return 'csv';
  }
  
  return 'other';
}

/**
 * Preview document from Firebase Storage
 * @param {Object} firebaseConfig - Firebase configuration
 * @param {Object} storageRef - Firebase storage reference
 * @param {string} filePath - Path to file in storage
 * @param {string} fileName - Name of the file
 * @param {boolean} fullScreen - Whether to display in full screen
 * @returns {Promise<Object>} - Preview data including URL and content type
 */
export async function previewDocument(firebaseConfig, storageRef, filePath, fileName, fullScreen = false) {
  try {
    const previewData = await downloadFromSDK(
      firebaseConfig,
      storageRef,
      'preview',
      null,
      fileName,
      filePath,
      false
    );
    
    if (!previewData) {
      throw new Error('Failed to load preview data');
    }
    
    return {
      url: previewData,
      fileType: getFileType(fileName),
      fullScreen: fullScreen
    };
  } catch (error) {
    console.error('Error previewing document:', error);
    throw error;
  }
}

/**
 * Convert text file content to readable string
 * @param {Blob} blob - File blob
 * @returns {Promise<string>} - Text content
 */
export async function readTextFile(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsText(blob);
  });
}

/**
 * Create a full-screen preview container
 * @param {string} contentHtml - HTML content to display in full screen
 * @returns {HTMLElement} - The created full-screen container
 */
export function createFullScreenPreview(contentHtml) {
  // Create full-screen container
  const container = document.createElement('div');
  container.className = 'fullscreen-preview';
  container.style.cssText = 'position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.9); z-index: 9999; display: flex; flex-direction: column;';
  
  // Create header with close button
  const header = document.createElement('div');
  header.className = 'fullscreen-preview-header';
  header.style.cssText = 'display: flex; justify-content: flex-end; padding: 16px;';
  
  const closeBtn = document.createElement('button');
  closeBtn.innerHTML = '✕';
  closeBtn.className = 'fullscreen-close-btn';
  closeBtn.style.cssText = 'background: transparent; border: none; color: white; font-size: 24px; cursor: pointer;';
  closeBtn.onclick = () => container.remove();
  
  header.appendChild(closeBtn);
  container.appendChild(header);
  
  // Create content container
  // DED-1131: Changed align-items from 'center' to 'flex-start' to show top of document
  const content = document.createElement('div');
  content.className = 'fullscreen-preview-content';
  content.style.cssText = 'flex: 1; display: flex; align-items: flex-start; justify-content: center; overflow: auto; padding: 20px; padding-top: 0;';
  content.innerHTML = contentHtml;
  
  container.appendChild(content);
  document.body.appendChild(container);
  
  return container;
}
/*
  This is a function that will download a file from the firebase storage bucket.
  It takes in the following parameters:
  action: 'download' or 'display'
  selector: the selector of the element to display the image in
  fileName: the name of the file to download
  path: the path to the file in the storage bucket
  isExample: a boolean that determines if the function should use the example file or not

  The function will return the url of the file if the action is 'display' and the selector is not null.

  Example:
  Display an Image:
  let imgURL = downloadFromSDK(firebaseConfig, storageRef, 
    'display',
    '#companyImg',
    'companyLogo.png',
    'companyLogos/companyName/logo.png',
    false
  );
  document.getElementById('companyImg').src = imgURL;

  Download a File:
  downloadFromSDK(firebaseConfig, storageRef, 
    'download',
    null,
    'user_reports.csv',
    'companyReports/companyName/user_reports.csv',
    false
  );
*/

// Global Fixes for all pages

export async function getCompanyImgLink(firebaseConfig, storageRef, companyID = window.companyID, forceError = false) {
  return await downloadFromSDK(
    firebaseConfig,
    storageRef,
    'pdf',
    '#companyImg',
    companyID + '_logo.png',
    'companyLogos/' + companyID + '/' + companyID + '_logo.png',
    forceError
  ).then((url) => {
    // console.log('[getCompanyImg4PDF]', url);
    return url;
  });
}
export function getCompanyImg(firebaseConfig, storageRef) {
  downloadFromSDK(
    firebaseConfig,
    storageRef,
    'display',
    '#companyImg',
    companyID + '_logo.png',
    'companyLogos/' + companyID + '/' + companyID + '_logo.png',
  );
}

export function setCompanyImg(firebaseConfig, storageRef, companyID) {
  downloadFromSDK(
    firebaseConfig,
    storageRef,
    'display',
    `#tenancy_${companyID} img`,
    companyID + '_logo.png',
    'companyLogos/' + companyID + '/' + companyID + '_logo.png',
  );
}

export async function getCompanyImg4PDF(firebaseConfig, storageRef, companyID) {
  return await downloadFromSDK(
    firebaseConfig,
    storageRef,
    'pdf',
    '#companyImg',
    companyID + '_logo.png',
    'companyLogos/' + companyID + '/' + companyID + '_logo.png',
  ).then((url) => {
    // console.log('[getCompanyImg4PDF]', url);
    return url;
  });
}

export function getCompanyLogoImg() {
  downloadFromSDK(
    firebaseConfig,
    storageRef,
    'display',
    '#companyLogoImg',
    companyID + '_logo.png',
    'companyLogos/' + companyID + '/' + companyID + '_logo.png',
  );
}

// SUPPORTING DOCS REQUIRES THIS
